/// <amd-module name="Build/Admin/Common/Actions/ResourceLimitActionCreator" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

import { ResourceLimit } from "DistributedTask/Client/Contracts/TaskAgent";

import { ResourceLimitActions } from "Build/Admin/Common/Actions/ResourceLimitActions";
import { Telemetry, StoreStatus } from "Build/Admin/Common/Constants";
import { AgentPoolSource } from "Build/Admin/Common/Sources/AgentPoolSource";
import { ResourceLimitStore } from "Build/Admin/Common/Stores/ResourceLimitStore";

export interface IResourceLimitActionCreatorOptions {
    pageContext: IVssPageContext;
    agentPoolSource: AgentPoolSource;
    resourceLimitActions: ResourceLimitActions;
    resourceLimitStore: ResourceLimitStore;
}

export class ResourceLimitActionCreator {
    private _pageContext: IVssPageContext;
    private _agentPoolSource: AgentPoolSource;
    private _resourceLimitActions: ResourceLimitActions;
    private _resourceLimitStore: ResourceLimitStore;

    constructor(options: IResourceLimitActionCreatorOptions) {
        this._pageContext = options.pageContext;
        this._agentPoolSource = options.agentPoolSource;
        this._resourceLimitActions = options.resourceLimitActions;
        this._resourceLimitStore = options.resourceLimitStore;
    }

    public fetchResourceLimits(): void {
        if (this._resourceLimitStore.state.resourceLimitsStatus === StoreStatus.None) {
            this._resourceLimitActions.resourceLimitsStatusUpdated.invoke(StoreStatus.Loading);
            this._agentPoolSource.getResourceLimitsAsync().then(
                (resourceLimits: ResourceLimit[]) => {
                    this._resourceLimitActions.resourceLimitsUpdated.invoke(resourceLimits);
                },
                (reason) => {
                    this._resourceLimitActions.resourceLimitsUpdated.invoke([]);
                    // Log the error but do not put an error in the UI
                    if (reason && reason.message) {
                        const service = this._pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
                        service.publishEvent(Telemetry.Area, Telemetry.PoolsAdminFeature, {
                            message: reason.message,
                            error: reason
                        });
                    }
                }
            );
        }
    }
}
